import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import AssessmentLevelContent from './AssessmentLevelContent';
import UpdateModal from '../modals/UpdateModal';
import CreateModal from '../modals/CreateModal';

const form = {
  keyword: '',
};

function AssessmentLevelContainer({
  match,
  history,
  getAssessmentLevelList,
  assessmentLevelList,
  isLoading,
  assessmentLevelListPager,
  removeAssessmentLevel,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Assessment Level',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal defaultValues={data.attributes} id={data.id} />,
      title: 'Update Assessment Level',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Assessment Level?',
      () => {
        removeAssessmentLevel(data.id, () => {
          getAssessmentLevelList();
          history.push(`/rpt/machinery/machinery-settings/assessment-level`);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getAssessmentLevelList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getAssessmentLevelList({ name: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:assessmentLevelId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Assessment Level"
            getData={getAssessmentLevelList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:assessmentLevelId?`}
            listName="assessmentLevels"
            label="Assessment Level"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.classification')}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {' '}
                  Assessment Level: {_.get(
                    item,
                    'attributes.assessment_level'
                  )}{' '}
                </h4>
              </div>
            )}
            noRightCard
            isLoading={isLoading}
            selected={params.assessmentLevelId}
            data={assessmentLevelList}
            dataPager={assessmentLevelListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:assessmentLevelId?`}
                    render={() => (
                      <AssessmentLevelContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:assessmentLevelId?`}
                  render={() =>
                    !params.assessmentLevelId &&
                    assessmentLevelList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(
                          assessmentLevelList,
                          '0.id'
                        )}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

AssessmentLevelContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getAssessmentLevelList: PropTypes.instanceOf(Function).isRequired,
  assessmentLevelList: PropTypes.instanceOf(Array).isRequired,
  assessmentLevelListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  removeAssessmentLevel: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  assessmentLevelList: _.get(api, `${c.GET_ASSESSMENT_LEVEL_LIST}.list`) || [],
  assessmentLevelListPager:
    _.get(api, `${c.GET_ASSESSMENT_LEVEL_LIST}.pager`) || {},
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_ASSESSMENT_LEVEL_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AssessmentLevelContainer);
